import { createFileRoute } from "@tanstack/react-router";
import { integerParam, stringParam } from "../../../lib/url-state";
import {
  WorkbenchPage,
  type WorkbenchSearch,
} from "../../../workspaces/label/pages/WorkbenchPage";

export const Route = createFileRoute("/_console/label/")({
  validateSearch: (search: Record<string, unknown>): WorkbenchSearch => ({
    q: stringParam(search.q),
    page: integerParam(search.page, { min: 0 }),
  }),
  component: LabelHome,
});

function LabelHome() {
  const state = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <WorkbenchPage
      state={state}
      onStateChange={(patch, options) =>
        void navigate({
          replace: options?.replace,
          search: (current) => ({ ...current, ...patch }),
        })
      }
    />
  );
}
